import { action } from 'typesafe-actions'
import { Job } from '@models/job'
import {RequestData} from "@models/axios";

export const enum JobsActionTypes {
    FETCH_REQUEST = '@@jobs/FETCH_REQUEST',
    FETCH_SUCCESS = '@@jobs/FETCH_SUCCESS',
    FETCH_ERROR = '@@jobs/FETCH_ERROR',

    DELETE_REQUEST = '@@jobs/DELETE_REQUEST',
    DELETE_SUCCESS = '@@jobs/DELETE_SUCCESS',
    DELETE_ERROR = '@@jobs/DELETE_ERROR',

    CREATE_REQUEST = '@@jobs/CREATE_REQUEST',
    CREATE_SUCCESS = '@@jobs/CREATE_SUCCESS',
    CREATE_ERROR = '@@jobs/CREATE_ERROR',

    UPDATE_REQUEST = '@@jobs/UPDATE_REQUEST',
    UPDATE_SUCCESS = '@@jobs/UPDATE_SUCCESS',
    UPDATE_ERROR = '@@jobs/UPDATE_ERROR',
}



export const fetchRequest = (data:RequestData) => action(JobsActionTypes.FETCH_REQUEST, data);
export const fetchSuccess = (data: Job[]) => action(JobsActionTypes.FETCH_SUCCESS, data);
export const fetchError = (message: string) => action(JobsActionTypes.FETCH_ERROR, message);

export const deleteRequest = (data:RequestData) => action(JobsActionTypes.DELETE_REQUEST, data);
export const deleteSuccess = (data:RequestData) => action(JobsActionTypes.DELETE_SUCCESS, data);
export const deleteError = (message: string) => action(JobsActionTypes.DELETE_ERROR, message);

export const createRequest = (data:RequestData) => action(JobsActionTypes.CREATE_REQUEST, data);
export const createSuccess = (data: Job[]) => action(JobsActionTypes.CREATE_SUCCESS, data);
export const createError = (message: string) => action(JobsActionTypes.CREATE_ERROR, message);

export const updateRequest = (data:RequestData) => action(JobsActionTypes.UPDATE_REQUEST, data);
export const updateSuccess = (data: Job[]) => action(JobsActionTypes.UPDATE_SUCCESS, data);
export const updateError = (message: string) => action(JobsActionTypes.UPDATE_ERROR, message);